/**
 * @description: 是否是浏览器环境环境
 */
export const isBrowser = typeof window !== 'undefined';
